"use client"

import Image from "next/image"
import { useCallback } from "react"
import { RiArrowRightCircleLine } from "react-icons/ri"

import { CLIENT_HOMEPAGE_LINK } from "@/constants"
import { useLocaleStrings } from "@/providers/localeStrings/client"

import { useShowMessage } from "./hooks"
import { ContentContainer, LinksContainer, Main, Paragraph, StyledButton, StyledLink } from "./styled"

/**
 * Warning message when screen is to small
 *
 * @returns JSX.Element
 */
const ScreenSizeWarning = () => {
  // text translations
  const {
    SCREEN_SIZE_WARNING_TEXT,
    SCREEN_SIZE_WARNING_DISMISS_BUTTON,
    SCREEN_SIZE_WARNING_LINK_BUTTON,
    SCREEN_SIZE_WARNING_LINK_IMPRINT,
    SCREEN_SIZE_WARNING_LINK_DATA_PROTECTION,
    SCREEN_SIZE_WARNING_LINK_MAIN,
  } = useLocaleStrings()
  const [showWarning, dismiss] = useShowMessage()

  // dismiss the message if user requests it
  const triggerDismiss = useCallback(() => {
    dismiss()
  }, [dismiss])

  // if message is set to false, display nothing
  if (!showWarning) {
    return null
  }

  return (
    <Main>
      <ContentContainer>
        <Image src="/images/logo.png" alt="einzA logo image" width={60} height={24} quality={100} />
        <Paragraph text={SCREEN_SIZE_WARNING_TEXT} large />
        <StyledButton handleClick={() => triggerDismiss()} rounded>
          <RiArrowRightCircleLine />
          {SCREEN_SIZE_WARNING_DISMISS_BUTTON}
        </StyledButton>
        <StyledButton targetBlank seo href={CLIENT_HOMEPAGE_LINK} rounded>
          <RiArrowRightCircleLine />
          {SCREEN_SIZE_WARNING_LINK_BUTTON}
        </StyledButton>
        <LinksContainer>
          <StyledLink targetBlank seo href={`${CLIENT_HOMEPAGE_LINK}/impressum`} rounded small>
            {SCREEN_SIZE_WARNING_LINK_IMPRINT}
          </StyledLink>
          <StyledLink targetBlank seo href={`${CLIENT_HOMEPAGE_LINK}/datenschutz`} rounded small>
            {SCREEN_SIZE_WARNING_LINK_DATA_PROTECTION}
          </StyledLink>
          <StyledLink targetBlank seo href={CLIENT_HOMEPAGE_LINK} rounded small>
            {SCREEN_SIZE_WARNING_LINK_MAIN}
          </StyledLink>
        </LinksContainer>
      </ContentContainer>
    </Main>
  )
}

export { ScreenSizeWarning }
